module.exports = __webpack_public_path__ + "static/media/winner.8e7537e3.jpeg";